/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
// eslint-disable-next-line no-plusplus
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
// eslint-disable-next-line no-plusplus
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line spaced-comment
// eslint-disable-line no-plusplus
// eslint-disable-next-line spaced-comment
// eslint-disable-next-line spaced-comment
import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  IconButton,
} from "@material-ui/core";
import WarningIcon from "@mui/icons-material/Warning";
import clsx from "clsx";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import axios from "axios";
import styles from "./OperativeBatchTimeBooking.module.css";
import {
  CustomFormGroup,
  CustomDatePicker,
  ValidatingTextField,
} from "../../components/FormComponents";
import BackButton from "../../components/BackButton/BackButton";
import {
  MESSAGE_TYPE,
  RESOURCE_TYPE,
} from "../../constants";
import { withAllowedOperationsProvider } from "../../hocs";
import { CustomTab, Button, AuthChecker } from "../../atomicComponents";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import { setLogin } from '../../redux/features/auth/actions';
import apiService from "../../apis/apiService";

const BatchTimeBooking = () => {
  const history = useHistory();
  const dispatch= useDispatch();
  const [sessionData, setSessionData] = useState([]);
  const { showPopup } = usePopupManager();
  const handleHrsMouseLeave = (i) => {
    const newSessionRow = {};
    Object.keys(sessionTempData[0]).forEach((key) => {
      newSessionRow[key] = sessionTempData[0][key];
    });
    const hrs = sessionTempData[i]['hrs']
    if (hrs !== "" && hrs !== "0") {
      if (isMultipleOfQuarter(parseFloat(hrs)) !== true) {
        let items = [...sessionTempData]
        let item = { ...items[i], hrs: "" };
        items[i] = item
        const totalHours = myState?.totalHours;
        const bookedHrs = items.reduce((total, obj) => {
          if (obj.hrs !== "") {
            total += parseFloat(obj.hrs);
          }
          return total;
        }, 0);
        const remainingHours = totalHours - bookedHrs;
        setState((prevData) => ({
          ...prevData,
          remainingHours,
          bookedHours: bookedHrs,
        }));
        setSessionTempData(items)
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: `Please enter hours in whole numbers or increments of 0.25.`,
        });

      }
    }
    else if (hrs === "0") {
      let items = [...sessionTempData]
      let item = { ...items[i], hrs: "" };
      items[i] = item
      setSessionTempData(items)
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: `Hours min value should be 0.25.`,
      });
    }
    setSessionData((prevData) => {
      const newData = [...prevData];
      newData.push(newSessionRow);
      return newData;
    });
  };
  const isMultipleOfQuarter = (value) => {
    return Number.isInteger(value) || (value * 100) % 25 === 0;
  }

  const [deleteClicked, setDeleteClicked] = useState(false);
  const [operativeList, setOperativeList] = useState([]);
  const [indirectProjectsList, setIndirectProjectsList] = useState([]);
  const [projectsDropdown, setProjectsDropdown] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectionOptions, setSelectionOptions] = useState([
    {
      projectOption: [
        { value: "Projects", label: "Projects" },
        { value: "Indirect Projects", label: "Indirect Projects" },
      ],
    },
  ]);
  const [operativesDetails, setOperativesDetails] = useState([]);
  const [changeIndex, setChangeIndex] = useState([]);
  const [seletedDates, setSeletedDates] = useState("");
  const [operativeID, setOperativeID] = useState("");
  const [selectedDates, setSelectedDates] = useState([]);
  const [updatedKey, setUpdatedKey] = useState("");
  const [isMobileDevice, setIsMobileDevice] = useState(window.innerWidth <= 450)
  const [allowedToDate, setAllowedToDate] = useState("");
  const [allowedFromDate, setAllowedFromDate] = useState("");

  const handleWindowSizeChange = () => {
    setIsMobileDevice(window.innerWidth <= 450);
  }
  
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  useEffect(() => {
    let data = {}
    axios.post(`${baseUrl}timeBooking/checkValidDate`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials:true
    }).then((res) => {
      dispatch(setLogin({...auth, recentStatus: res.status}))
      setAllowedFromDate(res.data.data[0][0]);
      setAllowedToDate(res.data.data[0][1]);
    })
    .catch((error) =>{
      dispatch(setLogin({...auth, recentStatus: error.response.status }));
    });
  }, []);

  const [sessionTempData, setSessionTempData] = useState([
    {
      project_type: "",
      isIndirectProject: false,
      barrel: "",
      project_details: "",
      evm_activity: "",
      module_mfl: "",
      hrs: "",
    },
  ]);

  useEffect(() => {
    const changeIndexValue = changeIndex;
    if (
      changeIndex === 0 &&
      updatedKey === "project_type" &&
      seletedDates.length > 1
    ) {
      const i = changeIndex;
      setExistingData([
        {
          project_type: (
            <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "14px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "250px",
               })  
              }}
              // className={clsx(styles.select, styles.sel2)}
              value={
                sessionTempData[i] ? sessionTempData[i]["project_type"] : ""
              }
              options={
                selectionOptions[i] ? selectionOptions[i]["projectOption"] : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "project_type",
                  i,
                  selectionOptions,
                  sessionTempData,
                  indirectProjectsList
                )
              }
              name="projectOption"
            />
          ),
          barrel: (
            <Select
              // className={clsx(styles.select, styles.sel2)}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '35px',
                  height: '100%',
                 
                  '&:hover': {
                    borderColor: '#E9DEAE'
                  },
                }),
                menuList: provided => ({
                  ...provided,
                  fontSize:isMobileDevice ? "10px" : "14px",
                  '&::-webkit-scrollbar': {
                    width: '4px !important',
                    height: '6px',
                    display: 'block !important',
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#f17c7c',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#da6363',
                  },
                }),
        
                multiValue: provided => ({
                  ...provided,
                  backgroundColor: '#C9AF28',
                  maxWidth: '140px'
                }),
                singleValue: provided => ({
                  ...provided,
                  color: 'black',
                  fontWeight:"400"
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                multiValueRemove: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                valueContainer: provided => ({
                  ...provided,
                  cursor: 'text'
                }),
                menu: styles => ({ ...styles,                 
                  width: isMobileDevice ? "100px" : "450px",
                 })  
              }}
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              value={sessionTempData[i] ? sessionTempData[i]["barrel"] : ""}
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? projectsDropdown?.BarrelInfoList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "barrel",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="barrel"
            />
          ),
          project_details: (
            <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "14px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "450px",
               })  
            }}
              // className={clsx(styles.select, styles.sel2)}
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? selectionOptions[i]?.project_details
                  : sessionTempData[i]?.project_type?.value ===
                    "Indirect Projects"
                    ? indirectProjectsList
                    : ""
              }
              value={
                sessionTempData[i] ? sessionTempData[i]["project_details"] : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "project_details",
                  i,
                  selectionOptions,
                  sessionTempData,
                  indirectProjectsList
                )
              }
              name="projectDetails"
            />
          ),
          evm_activity: (
            <Select
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '35px',
                  height: '100%',
                 
                  '&:hover': {
                    borderColor: '#E9DEAE'
                  },
                }),
                menuList: provided => ({
                  ...provided,
                  fontSize:isMobileDevice ? "10px" : "14px",
                  '&::-webkit-scrollbar': {
                    width: '4px !important',
                    height: '6px',
                    display: 'block !important',
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#f17c7c',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#da6363',
                  },
                }),
        
                multiValue: provided => ({
                  ...provided,
                  backgroundColor: '#C9AF28',
                  maxWidth: '140px'
                }),
                singleValue: provided => ({
                  ...provided,
                  color: 'black',
                  fontWeight:"400"
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                multiValueRemove: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                valueContainer: provided => ({
                  ...provided,
                  cursor: 'text'
                }),
                menu: styles => ({ ...styles,                 
                  width: isMobileDevice ? "100px" : "450px",
                 })  
              }}
              // className={clsx(styles.select, styles.sel2)}
              value={
                sessionTempData[i] ? sessionTempData[i]["evm_activity"] : ""
              }
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? selectionOptions[i]?.GateList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "evm_activity",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="evmActivity"
            />
          ),
          module_mfl: (
            <Select
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '35px',
                  height: '100%',
                 
                  '&:hover': {
                    borderColor: '#E9DEAE'
                  },
                }),
                menuList: provided => ({
                  ...provided,
                  fontSize:isMobileDevice ? "10px" : "14px",
                  '&::-webkit-scrollbar': {
                    width: '4px !important',
                    height: '6px',
                    display: 'block !important',
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#f17c7c',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#da6363',
                  },
                }),
        
                multiValue: provided => ({
                  ...provided,
                  backgroundColor: '#C9AF28',
                  maxWidth: '140px'
                }),
                singleValue: provided => ({
                  ...provided,
                  color: 'black',
                  fontWeight:"400"
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                multiValueRemove: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                valueContainer: provided => ({
                  ...provided,
                  cursor: 'text'
                }),
                menu: styles => ({ ...styles,                 
                  width: isMobileDevice ? "100px" : "250px",
                 })  
              }}
              // className={clsx(styles.select, styles.sel2)}
              value={sessionTempData[i] ? sessionTempData[i]["module_mfl"] : ""}
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? projectsDropdown?.mflList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "module_mfl",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="module"
            />
          ),
          hrs: (
            <ValidatingTextField
              variant="outlined"
              size="small"
              value={sessionTempData[i] ? sessionTempData[i]["hrs"] : ""}
              onChange={(e) =>
                handleCustomSelectChange(
                  e,
                  "hrs",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="hour"
              onBlur={() => { handleHrsMouseLeave(i) }}
              inputProps={{
                "data-testid": "remark-input",
              }}
              style={{ width: "100%" }}
            />
          ),
        },
      ]);
    } else {
      let updatedTable = [];
      sessionTempData.map((row, i) => {
        updatedTable.push({
          project_type: (
            <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "14px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "250px",
               })  }}
              // className={clsx(styles.select, styles.sel2)}
              value={
                sessionTempData[i] ? sessionTempData[i]["project_type"] : ""
              }
              options={
                selectionOptions[i] ? selectionOptions[i]["projectOption"] : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "project_type",
                  i,
                  selectionOptions,
                  sessionTempData,
                  indirectProjectsList
                )
              }
              name="projectOption"
            />
          ),
          barrel: (
            <Select
              // className={clsx(styles.select, styles.sel2)}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '35px',
                  height: '100%',
                 
                  '&:hover': {
                    borderColor: '#E9DEAE'
                  },
                }),
                menuList: provided => ({
                  ...provided,
                  fontSize:isMobileDevice ? "10px" : "14px",
                  '&::-webkit-scrollbar': {
                    width: '4px !important',
                    height: '6px',
                    display: 'block !important',
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#f17c7c',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#da6363',
                  },
                }),
        
                multiValue: provided => ({
                  ...provided,
                  backgroundColor: '#C9AF28',
                  maxWidth: '140px'
                }),
                singleValue: provided => ({
                  ...provided,
                  color: 'black',
                  fontWeight:"400"
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                multiValueRemove: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                valueContainer: provided => ({
                  ...provided,
                  cursor: 'text'
                }),
                menu: styles => ({ ...styles,                 
                  width: isMobileDevice ? "100px" : "450px",
                 })  
              }}
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              value={sessionTempData[i] ? sessionTempData[i]["barrel"] : ""}
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? projectsDropdown?.BarrelInfoList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "barrel",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="barrel"
            />
          ),
          project_details: (
            <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "14px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "450px",
               })  
            }}
              // className={clsx(styles.select, styles.sel2)}
              value={
                sessionTempData[i] ? sessionTempData[i]["project_details"] : ""
              }
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? selectionOptions[i]?.project_details
                  : sessionTempData[i]?.project_type?.value ===
                    "Indirect Projects"
                    ? indirectProjectsList
                    : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "project_details",
                  i,
                  selectionOptions,
                  sessionTempData,
                  indirectProjectsList
                )
              }
              name="projectDetails"
            />
          ),
          evm_activity: (
            <Select
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '35px',
                  height: '100%',
                 
                  '&:hover': {
                    borderColor: '#E9DEAE'
                  },
                }),
                menuList: provided => ({
                  ...provided,
                  fontSize:isMobileDevice ? "10px" : "14px",
                  '&::-webkit-scrollbar': {
                    width: '4px !important',
                    height: '6px',
                    display: 'block !important',
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#f17c7c',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#da6363',
                  },
                }),
        
                multiValue: provided => ({
                  ...provided,
                  backgroundColor: '#C9AF28',
                  maxWidth: '140px'
                }),
                singleValue: provided => ({
                  ...provided,
                  color: 'black',
                  fontWeight:"400"
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                multiValueRemove: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                valueContainer: provided => ({
                  ...provided,
                  cursor: 'text'
                }),
                menu: styles => ({ ...styles,                 
                  width: isMobileDevice ? "100px" : "450px",
                 })  
              }}
              // className={clsx(styles.select, styles.sel2)}
              value={
                sessionTempData[i] ? sessionTempData[i]["evm_activity"] : ""
              }
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? selectionOptions[i]?.GateList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "evm_activity",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="evmActivity"
            />
          ),
          module_mfl: (
            <Select
              isDisabled={
                sessionTempData[i]
                  ? sessionTempData[i]["isIndirectProject"]
                  : false
              }
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '35px',
                  height: '100%',
                 
                  '&:hover': {
                    borderColor: '#E9DEAE'
                  },
                }),
                menuList: provided => ({
                  ...provided,
                  fontSize:isMobileDevice ? "10px" : "14px",
                  '&::-webkit-scrollbar': {
                    width: '4px !important',
                    height: '6px',
                    display: 'block !important',
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'none',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#f17c7c',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#da6363',
                  },
                }),
        
                multiValue: provided => ({
                  ...provided,
                  backgroundColor: '#C9AF28',
                  maxWidth: '140px'
                }),
                singleValue: provided => ({
                  ...provided,
                  color: 'black',
                  fontWeight:"400"
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                multiValueRemove: provided => ({
                  ...provided,
                  color: '#fff'
                }),
                valueContainer: provided => ({
                  ...provided,
                  cursor: 'text'
                }),
                menu: styles => ({ ...styles,                 
                  width: isMobileDevice ? "100px" : "250px",
                 })  
              }}
              // className={clsx(styles.select, styles.sel2)}
              value={sessionTempData[i] ? sessionTempData[i]["module_mfl"] : ""}
              options={
                sessionTempData[i]?.project_type?.value === "Projects"
                  ? projectsDropdown?.mflList
                  : ""
              }
              onChange={(selectedOption) =>
                checkDuplicates(
                  selectedOption,
                  "module_mfl",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="module"
            />
          ),
          hrs: (
            <ValidatingTextField
              variant="outlined"
              size="small"
              value={sessionTempData[i] ? sessionTempData[i]["hrs"] : ""}
              onChange={(e) =>
                handleCustomSelectChange(
                  e,
                  "hrs",
                  i,
                  selectionOptions,
                  sessionTempData
                )
              }
              name="hour"
              onBlur={() => { handleHrsMouseLeave(i) }}
              inputProps={{
                "data-testid": "remark-input",
              }}
              style={{ width: "100%" }}
            />
          ),
        });
      });
      setExistingData(updatedTable);
    }
  }, [sessionTempData, indirectProjectsList, selectionOptions, deleteClicked]);

  function ResetModal({ isPopupOpen, handleClose }) {
    return (
      <Dialog
        open={isPopupOpen}
        className={styles.popContainer}
        classes={{
          paper: styles.popupBox,
        }}
        data-testid="reset-popup"
      >
        <>
          <DialogTitle>
            <span className={styles.title1}>
              {/* <MdReplay style={{ height: "18px", width: "18px" }} /> */}
              <span className={styles.txt}>Dates To Book</span>
            </span>
          </DialogTitle>
          <DialogContent className={styles.content}>
            <TableSimple
              tableColumnData={datesToBook}
              tableHeaderLabel={["Date_50", "Day_50"]}
              TableRowHederAling="start"
              size="small"
              headerColor="#E6F2FF"
              className="custom-table"
            />
          </DialogContent>
          <DialogActions style={{justifyContent: 'center'}}>
            {/* <Button
              className={clsx(styles.actionButton, styles.transparentButton)}
              onClick={handleClose}
            >
              Cancel
            </Button> */}
            <Button
              className={clsx(styles.actionButton, styles.primaryActionButton)}
              variant="primary"
              onClick={(e) => {
                e.preventDefault();
                handleClose();
                // resetFields();
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </>
      </Dialog>
    );
  }

  const [existingData, setExistingData] = useState([
    {
      project_type: (
        <Select
        styles={{
          control: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            height: '100%',
           
            '&:hover': {
              borderColor: '#E9DEAE'
            },
          }),
          menuList: provided => ({
            ...provided,
            fontSize:isMobileDevice ? "10px" : "14px",
            '&::-webkit-scrollbar': {
              width: '4px !important',
              height: '6px',
              display: 'block !important',
              background: 'none',
            },
            '&::-webkit-scrollbar-track': {
              background: 'none',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#f17c7c',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#da6363',
            },
          }),
  
          multiValue: provided => ({
            ...provided,
            backgroundColor: '#C9AF28',
            maxWidth: '140px'
          }),
          singleValue: provided => ({
            ...provided,
            color: 'black',
            fontWeight:"400"
          }),
          multiValueLabel: provided => ({
            ...provided,
            color: '#fff'
          }),
          multiValueRemove: provided => ({
            ...provided,
            color: '#fff'
          }),
          valueContainer: provided => ({
            ...provided,
            cursor: 'text'
          }),
          menu: styles => ({ ...styles,                 
            width: isMobileDevice ? "100px" : "250px",
           })  }}
          // className={clsx(styles.select, styles.sel2)}
          value={sessionTempData[0] ? sessionTempData[0]["project_type"] : ""}
          options={
            selectionOptions[0] ? selectionOptions[0]["projectOption"] : ""
          }
          onChange={(selectedOption) =>
            checkDuplicates(
              selectedOption,
              "project_type",
              i,
              selectionOptions,
              sessionTempData,
              indirectProjectsList
            )
          }
          name="projectOption"
        />
      ),
      barrel: (
        <Select
        styles={{
          control: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            height: '100%',
           
            '&:hover': {
              borderColor: '#E9DEAE'
            },
          }),
          menuList: provided => ({
            ...provided,
            fontSize:isMobileDevice ? "10px" : "14px",
            '&::-webkit-scrollbar': {
              width: '4px !important',
              height: '6px',
              display: 'block !important',
              background: 'none',
            },
            '&::-webkit-scrollbar-track': {
              background: 'none',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#f17c7c',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#da6363',
            },
          }),
  
          multiValue: provided => ({
            ...provided,
            backgroundColor: '#C9AF28',
            maxWidth: '140px'
          }),
          singleValue: provided => ({
            ...provided,
            color: 'black',
            fontWeight:"400"
          }),
          multiValueLabel: provided => ({
            ...provided,
            color: '#fff'
          }),
          multiValueRemove: provided => ({
            ...provided,
            color: '#fff'
          }),
          valueContainer: provided => ({
            ...provided,
            cursor: 'text'
          }),
          menu: styles => ({ ...styles,                 
            width: isMobileDevice ? "100px" : "450px",
           })  
        }}
          // className={clsx(styles.select, styles.sel2)}
          isDisabled={
            sessionTempData[0] ? sessionTempData[0]["isIndirectProject"] : false
          }
          value={sessionTempData[0] ? sessionTempData[0]["barrel"] : ""}
          options={
            sessionTempData[0]?.project_type?.value === "Projects"
              ? projectsDropdown?.BarrelInfoList
              : ""
          }
          onChange={(selectedOption) =>
            checkDuplicates(
              selectedOption,
              "barrel",
              i,
              selectionOptions,
              sessionTempData
            )
          }
          name="barrel"
        />
      ),
      project_details: (
        <Select
        styles={{
          control: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            height: '100%',
           
            '&:hover': {
              borderColor: '#E9DEAE'
            },
          }),
          menuList: provided => ({
            ...provided,
            fontSize:isMobileDevice ? "10px" : "14px",
            '&::-webkit-scrollbar': {
              width: '4px !important',
              height: '6px',
              display: 'block !important',
              background: 'none',
            },
            '&::-webkit-scrollbar-track': {
              background: 'none',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#f17c7c',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#da6363',
            },
          }),
  
          multiValue: provided => ({
            ...provided,
            backgroundColor: '#C9AF28',
            maxWidth: '140px'
          }),
          singleValue: provided => ({
            ...provided,
            color: 'black',
            fontWeight:"400"
          }),
          multiValueLabel: provided => ({
            ...provided,
            color: '#fff'
          }),
          multiValueRemove: provided => ({
            ...provided,
            color: '#fff'
          }),
          valueContainer: provided => ({
            ...provided,
            cursor: 'text'
          }),
          menu: styles => ({ ...styles,                 
            width: isMobileDevice ? "100px" : "450px",
           })  
        }}
          // className={clsx(styles.select, styles.sel2)}
          value={
            sessionTempData[0] ? sessionTempData[0]["project_details"] : ""
          }
          options={
            sessionTempData[0]["project_type"]?.value === "Projects"
              ? selectionOptions[0]["project_details"]
              : sessionTempData[0]["project_type"]?.value ===
                "Indirect Projects"
                ? indirectProjectsList
                : ""
          }
          onChange={(selectedOption) =>
            checkDuplicates(
              selectedOption,
              "project_details",
              i,
              selectionOptions,
              sessionTempData,
              indirectProjectsList
            )
          }
          name="projectDetails"
        />
      ),
      evm_activity: (
        <Select
          isMandatory
          // markIfUnselected={highlightMandatoryFields}
          // resetAllVisitedFields={resetAllVisitedFields}
          // className={clsx(styles.select, styles.sel2)}
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '35px',
              height: '100%',
             
              '&:hover': {
                borderColor: '#E9DEAE'
              },
            }),
            menuList: provided => ({
              ...provided,
              fontSize:isMobileDevice ? "10px" : "14px",
              '&::-webkit-scrollbar': {
                width: '4px !important',
                height: '6px',
                display: 'block !important',
                background: 'none',
              },
              '&::-webkit-scrollbar-track': {
                background: 'none',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#f17c7c',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#da6363',
              },
            }),
    
            multiValue: provided => ({
              ...provided,
              backgroundColor: '#C9AF28',
              maxWidth: '140px'
            }),
            singleValue: provided => ({
              ...provided,
              color: 'black',
              fontWeight:"400"
            }),
            multiValueLabel: provided => ({
              ...provided,
              color: '#fff'
            }),
            multiValueRemove: provided => ({
              ...provided,
              color: '#fff'
            }),
            valueContainer: provided => ({
              ...provided,
              cursor: 'text'
            }),
            menu: styles => ({ ...styles,                 
              width: isMobileDevice ? "100px" : "450px",
             })  
          }}
          isClearable
          value={sessionTempData[0] ? sessionTempData[0]["evm_activity"] : ""}
          options={
            sessionTempData[0]?.project_type?.value === "Projects"
              ? selectionOptions[0]?.GateList
              : ""
          }
          onChange={(selectedOption) =>
            checkDuplicates(
              selectedOption,
              "evm_activity",
              i,
              selectionOptions,
              sessionTempData
            )
          }
          name="evmActivity"
        />
      ),
      module_mfl: (
        <Select
          isMandatory
          // markIfUnselected={highlightMandatoryFields}
          // resetAllVisitedFields={resetAllVisitedFields}
          // className={clsx(styles.select, styles.sel2)}
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '35px',
              height: '100%',
             
              '&:hover': {
                borderColor: '#E9DEAE'
              },
            }),
            menuList: provided => ({
              ...provided,
              fontSize:isMobileDevice ? "10px" : "14px",
              '&::-webkit-scrollbar': {
                width: '4px !important',
                height: '6px',
                display: 'block !important',
                background: 'none',
              },
              '&::-webkit-scrollbar-track': {
                background: 'none',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#f17c7c',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#da6363',
              },
            }),
    
            multiValue: provided => ({
              ...provided,
              backgroundColor: '#C9AF28',
              maxWidth: '140px'
            }),
            singleValue: provided => ({
              ...provided,
              color: 'black',
              fontWeight:"400"
            }),
            multiValueLabel: provided => ({
              ...provided,
              color: '#fff'
            }),
            multiValueRemove: provided => ({
              ...provided,
              color: '#fff'
            }),
            valueContainer: provided => ({
              ...provided,
              cursor: 'text'
            }),
            menu: styles => ({ ...styles,                 
              width: isMobileDevice ? "100px" : "250px",
             })  
          }}
          isClearable
          value={sessionTempData[0] ? sessionTempData[0]["module_mfl"] : ""}
          options={
            sessionTempData[0]?.project_type?.value === "Projects"
              ? projectsDropdown?.mflList
              : ""
          }
          onChange={(selectedOption) =>
            checkDuplicates(
              selectedOption,
              "module_mfl",
              i,
              selectionOptions,
              sessionTempData
            )
          }
          name="module"
        />
      ),
      hrs: (
        <ValidatingTextField
          variant="outlined"
          size="small"
          value={sessionTempData[0] ? sessionTempData[0]["hrs"] : ""}
          onChange={(e) =>
            handleCustomSelectChange(
              e,
              "hrs",
              i,
              selectionOptions,
              sessionTempData
            )
          }
          name="hour"
          onBlur={() => { handleHrsMouseLeave(i) }}
          inputProps={{
            "data-testid": "remark-input",
          }}
          style={{ width: "100%" }}
        />
      ),
    },
  ]);

  // const baseUrl='http://127.0.0.1:8000/file/'
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const auth = useSelector((state) => state.auth); // useSelector
  let {
    userName,
    personNumber,
    companyCode,
    businessArea,
    bookingStatus,
    costCenter,
    userRole,
    sessionId,
    persArea,
  } = auth;
  const [plant, setPlant] = useState(null);
  const [flag, show] = useState(false);
  const [Bc, setBC] = useState(null);
  const [bcArray, setBcArray] = useState([]);
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [datesToBook, setDatesToBook] = useState([]);
  const [swapDatesColumn, setSwapDatesColumn] = useState([]);
  const [swapDatesColumnTemp, setSwapDatesColumnTemp] = useState([]);
  const [swapDates, setSwapDates] = useState([]);
  const [swapDatesTemp, setSwapDatesTemp] = useState([]);
  const [viewDatesToBook, setViewDatesToBook] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [tableArray, setTableArray] = useState([]);
  const [loader, setLoader] = useState(true);
  const [asnCount, setAsnCount] = useState(0);
  const [myState, setState] = React.useState({
    pers_no: "",
    BU: { label: "", value: "" },
    SUB_BU: "",
    PLATFORM: "",
    FAMILY: "",
    project_def: "",
    toDate: null,
    fromDate: null,
    hrs: "",
    remainingHours: "",
    bookedHours: "",
    totalHours: "",
  });
  const resetOnBook = () => {
    setIndirectProjectsList([]);
    setProjectsDropdown([]);
    setSelectionOptions([
      {
        projectOption: [
          { value: "Projects", label: "Projects" },
          { value: "Indirect Projects", label: "Indirect Projects" },
        ],
      },
    ]);
    setSeletedDates([]);
    setChangeIndex("");
    setCheckedItems({});
    setSwapDatesColumn([]);
    setBookButtonClicked(false);
    setSwapDates([]);
    const totalHours = myState?.totalHours;
    setState((prevData) => ({
      ...prevData,
      remainingHours: totalHours,
      bookedHours: 0,
    }));
    setSessionTempData([
      {
        project_type: "",
        isIndirectProject: false,
        barrel: "",
        project_details: "",
        evm_activity: "",
        module_mfl: "",
        hrs: "",
      },
    ]);
  };
  const resetDatesAndProjects = () => {
    setIndirectProjectsList([]);
    setProjectsDropdown([]);
    setSelectionOptions([
      {
        projectOption: [
          { value: "Projects", label: "Projects" },
          { value: "Indirect Projects", label: "Indirect Projects" },
        ],
      },
    ]);
    setSeletedDates([]);
    setChangeIndex("");
    setCheckedItems({});
    setDatesToBook([]);
    setSwapDatesColumn([]);
    setBookButtonClicked(false);
    setSwapDates([]);
    const totalHours = myState?.totalHours;
    setState((prevData) => ({
      ...prevData,
      remainingHours: totalHours,
      bookedHours: 0,
    }));
    setSessionTempData([
      {
        project_type: "",
        isIndirectProject: false,
        barrel: "",
        project_details: "",
        evm_activity: "",
        module_mfl: "",
        hrs: "",
      },
    ]);
  };
  const resetState = () => {
    setState({ pers_no: "" });
    setIndirectProjectsList([]);
    setProjectsDropdown([]);
    setSelectionOptions([
      {
        projectOption: [
          { value: "Projects", label: "Projects" },
          { value: "Indirect Projects", label: "Indirect Projects" },
        ],
      },
    ]);
    setSeletedDates([]);
    setChangeIndex("");
    setOperativeID("");
    setCheckedItems({});
    setDatesToBook([]);
    setSwapDatesColumn([]);
    setBookButtonClicked(false);
    setSwapDates([]);
    const totalHours = myState?.totalHours;
    setState((prevData) => ({
      ...prevData,
      remainingHours: totalHours,
      bookedHours: 0,
    }));
    setSessionTempData([
      {
        project_type: "",
        isIndirectProject: false,
        barrel: "",
        project_details: "",
        evm_activity: "",
        module_mfl: "",
        hrs: "",
      },
    ]);
  };
  const [projectOption, setProjectOption] = useState([
    { value: "Projects", label: "Projects" },
    { value: "Indirect Projects", label: "Indirect Projects" },
  ]);
  const Projects = () => {
    const oprativeDetails = operativesDetails.filter(
      (item) => item?.emp_tkt_no === operativeID?.value
    )[0];
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    const apiFormatedData = {
      bc_no: operativeID?.bc_number,
      pers_no: personNumber,
      co_code: companyCode,
    };
    const apiFormatedDataJson = JSON.stringify(apiFormatedData);

    fetch(`${baseUrl}timeBooking/barrelInfoBookingIndividualDirectProject`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:"include"
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson.data) {
          const BarrelInfoList = [];
          responseJson.data?.BarrelInfo.map((barrel) => {
            const barrelData = {
              label: barrel[1],
              value: barrel[0],
            };
            BarrelInfoList.push(barrelData);
          });
          const GateList = responseJson.data?.GateList;
          const mflList = responseJson.data?.mflList;
          setProjectsDropdown({
            BarrelInfoList: BarrelInfoList,
            GateList: GateList,
            mflList: mflList,
          });
        }
      })
      .catch((error) => {
        console.info(error);
      });
  };
  const getProjects = (barrel, index) => {
    const oprativeDetails = operativesDetails.filter(
      (item) => item?.emp_tkt_no === operativeID?.value
    )[0];
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    if (barrel.value) {
      const oprativeDetails = operativesDetails.filter(
        (item) => item?.emp_tkt_no === operativeID?.value
      )[0];
      const apiFormatedData = {
        pers_no: personNumber,
        business_area: businessArea,
        barrel: barrel.value,
      };
      const apiFormatedDataJson = JSON.stringify(apiFormatedData);

      fetch(`${baseUrl}timeBooking/getOperativeProjectDetails`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          dispatch(setLogin({...auth, recentStatus: response.status}))
          return response.json();
          })
        .then((responseJson) => {
          if (responseJson.data) {
            const projectList = [];
            responseJson.data?.projectList.map((project) => {
              const projectData = {
                label: project?.project,
                value: project?.project_def,
              };
              projectList.push(projectData);
            });
            let tempProjectList = [...projects];
            const tempIndex = {
              ...tempProjectList[index],
              projects: responseJson.data?.projectList,
            };
            tempProjectList[index] = tempIndex;
            setProjects(tempProjectList);
            let tempOptions = [...selectionOptions];
            const tempOption = {
              ...tempOptions[index],
              project_details: projectList,
            };
            tempOptions[index] = tempOption;
            setSelectionOptions(tempOptions);
          }
        })
        .catch((error) => {
          console.info(error);
        });
    }
  };
  const getGateList = (project, index) => {
    const oprativeDetails = operativesDetails.filter(
      (item) => item?.emp_tkt_no === operativeID?.value
    )[0];
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    if (project.value) {
      const oprativeDetails = operativesDetails.filter(
        (item) => item?.emp_tkt_no === operativeID?.value
      )[0];
      const apiFormatedData = {
        pers_no: personNumber,
        project_def: project.value,
      };
      const apiFormatedDataJson = JSON.stringify(apiFormatedData);
      fetch(`${baseUrl}timeBooking/getGateList`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          dispatch(setLogin({...auth, recentStatus: response.status}))
          return response.json();
          })
        .then((responseJson) => {
          if (responseJson.data) {
            const GateList = responseJson.data?.GateList;
            // let tempProjectList = [...projects]
            // const tempIndex = {...tempProjectList[index], projects: responseJson.data?.projectList}
            // tempProjectList[index]= tempIndex
            // setProjects(tempProjectList)
            let tempOptions = [...selectionOptions];
            const tempOption = { ...tempOptions[index], GateList: GateList };
            tempOptions[index] = tempOption;
            setSelectionOptions(tempOptions);
          }
        })
        .catch((error) => {
          console.info(error);
        });
    }
  };
  const indirectProjects = () => {
    const oprativeDetails = operativesDetails.filter(
      (item) => item?.emp_tkt_no === operativeID?.value
    )[0];
    const data = {
      co_code: oprativeDetails?.co_code,
    };
    axios
      .post(`${baseUrl}timeBooking/indirectProjectsIndividualBooking`, data, {
        headers: {
          'Content-Type': 'application/json',

        },
        withCredentials:true
      })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        setIndirectProjectsList(response.data?.IndirectProjects);
      })
      .catch((error) => {
        dispatch(setLogin({...auth, recentStatus: error.response.status }));
        console.error("Error while calling API -> ", error);
      });
  };

  const checkDuplicates = (
    e,
    key,
    i,
    selectionOptions,
    sessionTempData,
    dropDownList
  ) => {
    if (key !== "hrs") {
      const list = [...sessionTempData];
      const row =
        e !== null
          ? { ...list[i], [key]: { label: e?.label, value: e?.value } }
          : { ...list[i], [key]: "" };
      list[i] = row;
      // let dataForCheck = [];
      const returnedList = list.map((row, i) => {
        let requiredFields = { ...row };
        if (row.project_type?.value === "Projects") {
          ["isIndirectProject", "hrs"].forEach((e) => delete requiredFields[e]);
        } else if (row.project_type?.value === "Indirect Projects") {
          [
            "barrel",
            "isIndirectProject",
            "evm_activity",
            "module_mfl",
            "hrs",
          ].forEach((e) => delete requiredFields[e]);
        } else {
          ["isIndirectProject", "hrs"].forEach((e) => delete requiredFields[e]);
        }
        return requiredFields;
      });
      const jsonObject = returnedList.map(JSON.stringify);
      const uniqueSet = new Set(jsonObject);
      const uniqueArray = Array.from(uniqueSet).map(JSON.parse);
      if (uniqueArray.length === returnedList.length) {
        if (key === "barrel") {
          getProjects(e, i);
        } else if (key === "project_details") {
          getGateList(e, i);
        }
        handleCustomSelectChange(
          e,
          key,
          i,
          selectionOptions,
          sessionTempData,
          dropDownList
        );
      } else {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: `Same Combination selection is not allowed`,
        });
      }
    }
  };
  const validateData = () => {
    let hasMissingRequiredFields = false;
    const returnedList = sessionTempData.map((row, i) => {
      let fieldsValidate = true;
      let requiredFields = { ...row };
      if (row.project_type?.value === "Projects") {
        fieldsValidate = Object.values(requiredFields).every((value) => {
          if (value === null || value === undefined || value === "") {
            return false;
          }
          return true;
        });
        return fieldsValidate;
      } else if (row.project_type?.value === "Indirect Projects") {
        ["barrel", "isIndirectProject", "evm_activity", "module_mfl"].forEach(
          (e) => delete requiredFields[e]
        );
        fieldsValidate = Object.values(requiredFields).every((value) => {
          if (value === null || value === undefined || value === "") {
            return false;
          }
          return true;
        });
        return fieldsValidate;
      } else {
        fieldsValidate = false;
        return fieldsValidate;
      }
    });
    hasMissingRequiredFields = (returnedList) => returnedList.every(Boolean);
    hasMissingRequiredFields = returnedList.every(
      (element) => element === true
    );
    if (hasMissingRequiredFields === false) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please fill all required fields.",
      });
      return false;
    } else {
      return true;
    }
  };

  const saveTimeBooking = () => {
    if (validateData() === true) {
      const checked = Object.keys(checkedItems).filter((key) => {
        return checkedItems[key] === true;
      });
      // const checkedDates = ['2023-09-09','2023-09-01', '2023-09-04', '2023-09-05', '2023-09-07']
      const operativeInfo = operativesDetails.filter((operative) => {
        return operative?.emp_tkt_no === operativeID?.value;
      })[0];
      let datesArray = checked.map((element) => new Date(element));
      let tempDates = [...swapDates];
      const fromDate = convert2(new Date(Math.min(...datesArray)));
      var result = [];
      const keysDate = Object.keys(swapDates[0]).slice(1);
      const dateList = Object.values(swapDates[0]).slice(1);
      const hrsList = Object.values(swapDates[1]).slice(1);
      let tempDatesList = dateList.map((date, index) => {
        return { date: date, hrs: hrsList[index] };
      });
      let tempProjectList = sessionTempData.map((project, index) => {
        return {
          project_details: project.project_details,
          hrs: parseFloat(project.hrs),
        };
      });
      for (var j = 0; j < tempDatesList.length; j++) {
        const dailyLimit = tempDatesList[j];
        let dailyHrsLimit = parseFloat(dailyLimit.hrs);
        for (var i = 0; i < tempProjectList.length && dailyLimit.hrs > 0; i++) {
          var project = tempProjectList[i];
          let projectHrs = parseFloat(project.hrs);
          var hoursToBook = Math.min(project.hrs, dailyLimit.hrs);
          dailyLimit.hrs -= hoursToBook;
          project.hrs -= hoursToBook;
          if (hoursToBook > 0) {
            let barrel = null;
            let module_mfl = null;
            let evm_activity = null;
            let wbs_no = null;
            let network = null;
            let code_code = project.project_details?.value;
            let project_def = null;
            if (sessionTempData[i]["project_type"]?.value === "Projects") {
              code_code = null;
              project_def = project.project_details?.value;
              barrel = sessionTempData[i]["barrel"]?.value;
              module_mfl = sessionTempData[i]["module_mfl"]?.value;
              evm_activity = sessionTempData[i]["evm_activity"]?.value;
              const projectDef = project.project_details?.value;
              const projectdata = projects[i]["projects"].filter((proData) => {
                return proData?.project_def === projectDef;
              })[0];
              wbs_no = projectdata?.wbs_no;
              network = projectdata?.network;
            }
            // const hrs = toString(hoursToBook, project.hrs, dailyLimit.hrs)
            result.push(
              // { project: project.project_details?.value, date: dailyLimit.date, bookedHours: hoursToBook }
              {
                pers_no: operativeID?.value,
                co_code: operativeInfo?.co_code,
                pers_area: operativeInfo?.pers_area,
                pers_sub_area: operativeInfo?.pers_subarea,
                booking_date: selectedDates[j],
                barrel_code: barrel,
                project_def: project_def,
                wbs_no: wbs_no,
                network: network,
                activity_no: evm_activity,
                mfl_id: module_mfl,
                str_user_id: operativeID?.value,
                no_of_hours: hoursToBook.toString(),
                cost_center: operativeInfo?.bc_number,
                code_code: code_code,
              }
            );
          }
        }
      }
      // console.log("result : ", result);
      const apiFormatedDataJson = JSON.stringify(result);
      // console.log("final", apiFormatedDataJson);
      const headerss = new Headers();
      headerss.append("Content-Type", "application/json");
      fetch(`${baseUrl}timeBooking/individualBookingSave`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          dispatch(setLogin({...auth, recentStatus: response.status}))
          return response.json();
          })
        .then((responseJson) => {
          if (responseJson.data[0][0] === "T") {
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: "Time Booking saved successfully...",
              reloads: true, // Set reload to true or false based on your condition
            });
            resetState();
          }else{
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: "Booking already available for selected date",
              reloads: true, // Set reload to true or false based on your condition
            });
          }
        })
        .catch((error) => {
          console.info(error);
        });
    }
  };

  const handleExtraCheckDuplicateBooking = async() =>{
    try {
      const payload = {
        'pers_no' : operativeID?.value,
        'dates' :selectedDates
      }
      const response = await apiService.CheckBookingDates(payload,dispatch)
      if(response?.data?.msg === 'Fail'){
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: response.data.message,
        })
        history.push('/home')
        
      }
    } catch (error) {
      console.error(error)
    }
  }
  
  useEffect(()=>{
  if(myState.remainingHours === 0){
    handleExtraCheckDuplicateBooking()
  }
  },[myState.remainingHours])

  const handleCustomSelectChange = (
    e,
    key,
    i,
    selectionOptions,
    sessionTempData,
    dropDownList
  ) => {
    setUpdatedKey(key);
    let value = null;
    if (key === "hrs" && e.target.value === undefined) {
      value = e.target.value;
    } else if (e === null || e.value === undefined) {
      value = ""; // Extract the value based on the key
    } else {
      value = e.value;
    }
    const index = selectionOptions.length;
    let items = [...sessionTempData];
    let rowOptions = [...selectionOptions];
    if (key === "project_type" && i === 0 && existingData.length > 1) {
      let updatedData = [];
      if (i === 0) {
        let item = {};
        if (sessionTempData[i].project_type?.value !== value && value !== "") {
          if (value === "Indirect Projects") {
            item = {
              isIndirectProject: true,
              [key]: { label: e?.label, value: e?.value },
              barrel: "",
              project_details: "",
              evm_activity: "",
              module_mfl: "",
              hrs: "",
            };
            const rowOption = {
              ...rowOptions[i],
              projectDetails: dropDownList,
            };
            rowOptions[i] = rowOption;
            setSelectionOptions(rowOptions);
          } else if (value === "Projects") {
            item = {
              isIndirectProject: false,
              [key]: { label: e?.label, value: e?.value },
              barrel: "",
              project_details: "",
              evm_activity: "",
              module_mfl: "",
              hrs: "",
            };
          }
          updatedData.push(item);
          setSessionTempData(updatedData);
        } else if (value === undefined || value === null || value === "") {
          item = {
            isIndirectProject: false,
            [key]: "",
            barrel: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
          updatedData.push(item);
          setSessionTempData(updatedData);
        }
      }
    } else {
      let item = { ...items[i] };
      if (key === "project_type" && value === "Indirect Projects") {
        if (value === "") {
          item = {
            isIndirectProject: true,
            [key]: "",
            barrel: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        } else {
          item = {
            ...items[i],
            isIndirectProject: true,
            [key]: { label: e?.label, value: e?.value },
            barrel: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
          const rowOption = {
            ...rowOptions[i],
            projectDetails: [...dropDownList],
          };
          rowOptions[i] = rowOption;
          setSelectionOptions(rowOptions);
        }
      } else if (key === "project_type") {
        if (value === "") {
          item = {
            isIndirectProject: false,
            [key]: "",
            barrel: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        } else {
          item = {
            ...items[i],
            isIndirectProject: false,
            [key]: { label: e?.label, value: e?.value },
            barrel: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        }
      } else if (key === "hrs") {
        const regex = /^(\d+(\.\d{0,2})?|\.\d{1,2})?$/;
        if (
          e.target.value != undefined ||
          e.target.value !== "" ||
          e.target.value !== null
        ) {
          if (regex.test(e.target.value) || e.target.value === '.' || e.target.value === '') {
            // const hour =
            // e.target.value.length >= 1 ? parseFloat(e.target.value) : "";
            const hour = parseFloat(e.target.value);

            let remainingHours = myState.remainingHours;
            let totalHours = myState.totalHours;
            let bookedHrs = myState?.bookedHours ? myState?.bookedHours : 0;
            if (hour === "") {
              let tempData = [...items];
              const tempRow = { ...tempData[i], [key]: e.target.value };
              tempData[i] = tempRow;
              // bookedHrs = tempData.reduce((total, obj) => parseFloat(obj.hrs) + total,0)
              bookedHrs = tempData.reduce((total, obj) => {
                if (obj.hrs !== "") {
                  total += parseFloat(obj.hrs);
                }
                return total;
              }, 0);
              remainingHours = totalHours - bookedHrs;
              setState((prevData) => ({
                ...prevData,
                remainingHours,
                bookedHours: bookedHrs,
              }));
              item = { ...items[i], [key]: e.target.value };
            } else if (hour < 0) {
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Booking Hours should not be negative or 0",
              });
            } else if (hour > 0) {
              let tempData = [...items];
              const tempRow = { ...tempData[i], [key]: e.target.value };
              tempData[i] = tempRow;
              bookedHrs = tempData.reduce((total, obj) => {
                if (obj.hrs !== "") {
                  total += parseFloat(obj.hrs);
                }
                return total;
              }, 0);
              remainingHours = totalHours - bookedHrs;
              if (bookedHrs <= totalHours && remainingHours >= 0) {
                setState((prevData) => ({
                  ...prevData,
                  remainingHours,
                  bookedHours: bookedHrs,
                }));
                item = { ...items[i], [key]: e.target.value };
              } else if (bookedHrs > totalHours) {
                showPopup({
                  type: MESSAGE_TYPE.INFORMATION,
                  contextText: MESSAGE_TYPE.INFORMATION,
                  info: "Over booking is not allowed",
                });
              }
            } else if (bookedHrs > totalHours) {
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Over booking is not allowed",
              });
            } else {
              item = { ...items[i], [key]: e.target.value };
            }
          }
        } else {
          item = { ...items[i], [key]: "" };
        }
      } else if (key === "barrel") {
        if (value === "") {
          item = {
            ...items[i],
            [key]: "",
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        } else if (items[i].barrel?.value !== value) {
          item = {
            ...items[i],
            [key]: { label: e?.label, value: e?.value },
            project_details: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        }
      } else if (key === "project_details") {
        if (value === "") {
          item = {
            ...items[i],
            [key]: "",
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        } else if (items[i].project_details?.value !== value) {
          item = {
            ...items[i],
            [key]: { label: e?.label, value: e?.value },
            evm_activity: "",
            module_mfl: "",
            hrs: "",
          };
        }
      } else if (value === "") {
        item = { ...items[i], isIndirectProject: false, [key]: "" };
      } else {
        item = { ...items[i], [key]: { label: e?.label, value: e?.value } };
      }
      items[i] = item;
      // console.log("item:  : ", item, i);
      let tempData = [...items];
      const totalHours = myState?.totalHours;
      const bookedHrs = tempData.reduce((total, obj) => {
        if (obj.hrs !== "") {
          total += parseFloat(obj.hrs);
        }
        return total;
      }, 0);
      const remainingHours = totalHours - bookedHrs;
      setState((prevData) => ({
        ...prevData,
        remainingHours,
        bookedHours: bookedHrs,
      }));
      setSessionTempData(items);
    }
    setChangeIndex(i);
  };
  // console.log("sessionTempData :", sessionTempData);

  const handleDelete = (index) => {
    setDeleteClicked(!deleteClicked);
    const totalHours = myState?.totalHours;
    if (sessionTempData.length > 1) {
      existingData.splice(index, 1);
      setExistingData(existingData);
      sessionTempData.splice(index, 1);
      const bookedHrs = sessionTempData.reduce((total, obj) => {
        if (obj.hrs !== "") {
          total += parseFloat(obj.hrs);
        }
        return total;
      }, 0);
      const remainingHours = totalHours - bookedHrs;
      setState((prevData) => ({
        ...prevData,
        remainingHours,
        bookedHours: bookedHrs,
      }));
      setSessionTempData(sessionTempData);
    } else if (sessionTempData.length === 1 && index === 0) {
      setSessionTempData([
        {
          project_type: "",
          isIndirectProject: false,
          barrel: "",
          project_details: "",
          evm_activity: "",
          module_mfl: "",
          hrs: "",
        },
      ]);
      setState((prevData) => ({
        ...prevData,
        remainingHours: totalHours,
        bookedHours: 0,
      }));
    }
  };

  const convert2 = (str) => {
    if (str == null) {
      return "";
    } else {
      let date = str;
      if (typeof str === "string") {
        date = new Date(str);
      }
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);

      return [date.getFullYear(), mnth, day].join("-"); // 03/08/2022
    }
  };
  const convertViewDate = (str) => {
    if (!str) {
      return "";
    }
    const m = moment(str, moment.ISO_8601, true);
    if (!m.isValid()) {
      const date = new Date(str);
      if (isNaN(date)) return ""; 
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [day, mnth, date.getFullYear()].join("-");
    }
    return m.format("DD-MM-YYYY");
  };
  const convertBookingDate = (str) => {
    if (!str) {
      return "";
    }
    const m = moment(str, moment.ISO_8601, true);
    if (!m.isValid()) {
      const date = new Date(str);
      if (isNaN(date)) return "";
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [day, mnth, date.getFullYear()].join("/");
    }
    return m.format("YYYY-MM-DD");
  };
  useEffect(() => {
    const getOperativeDetails = () => {
      const apiFormatedData = {
        supno: personNumber,
        // "supno": "280339",
      };
      const apiFormatedDataJson = JSON.stringify(apiFormatedData);
      // console.log("final", apiFormatedDataJson);
      const headerss = new Headers();
      headerss.append("Content-Type", "application/json");
      fetch(`${baseUrl}timeBooking/GetOperativeDetails`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          dispatch(setLogin({...auth, recentStatus: response.status}))
          return response.json();
          })
        .then((responseJson) => {
          if (responseJson.result) {
            const operativeDataList = [];
            responseJson.result.map((operative) => {
              const operativeData = {
                label: operative.emp_tkt_no + " - " + operative.complete_name,
                value: operative.emp_tkt_no,
                bc_number: operative.bc_number
              };
              operativeDataList.push(operativeData);
            });
            setOperativesDetails(responseJson.result);
            setOperativeList(operativeDataList);
          }
        })
        .catch((error) => {
          console.info(error);
        });
    };
    getOperativeDetails();
  }, [baseUrl, personNumber]);

  const handleOperativeIDChange = (operative) => {
    setState((prevData) => ({ ...prevData, operativeID: operative }));
    setOperativeID(operative);
    if (operative !== null) {
      getDatesToBook(operative.value);
    } else {
      setDatesToBook([]);
    }
  };
  const getDatesToBook = (empID) => {
    resetDatesAndProjects();
    const operativeInfo = operativesDetails.filter((operative) => {
      return operative?.emp_tkt_no === empID;
    })[0];
    console.info("operativeID?.value,", empID);
    const apiFormatedData = {
      pers_no: empID,
      co_code: operativeInfo?.co_code,
    };
    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}timeBooking/viewDatesToBook`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson.data.length > 0) {
          const finalData = [];
          const convertToDate = dateString => {
            const [day, month, year] = dateString.split('-');
            return new Date(`${year}-${month}-${day}`);
          };        
          // Sort the array based on the dates
          const sortedData = responseJson.data.sort((a, b) => convertToDate(a[0]) - convertToDate(b[0]));
          // console.log("sortedData",sortedData);
          responseJson.data.map((item) => {
            const data = {
              // selection: (
              //   <input
              //     type="checkbox"
              //     // onChange={(e) => handleCheckboxChange(e, moment(item[0]).format('DD-MM-YYYY'))}
              //     onChange={(e) => handleCheckboxChange(e, item[0])}
              //   />
              // ),
              date: item[0],
              day: item[1],
            };
            finalData.push(data);
          });
          // finalData.length
          setDatesToBook(finalData);
        } else {
          // console.log("No dates to Book");
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Selected opterative's booking is up to date",
          });
        }
      })
      .catch((error) => {
        console.info(error);
      });
  };
  const validDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return new Date(year, month - 1, day);
  };

  function mapResponse(swapData, response) {
    const days = response.map((item) =>
      moment(item.date).format("ddd").toUpperCase()
    );
    const hours = response.map((item) =>
      item.hrs === -1 ? "Booking Done" : item.hrs
    );

    return swapData.map((item, index) => {
      if (item.date === "Day") {
        return days.reduce((acc, day, i) => ({ ...acc, [`day+${i}`]: day }), {
          date: item.date,
        });
      } else if (item.date === "Hours") {
        return hours.reduce(
          (acc, hour, i) => ({ ...acc, [`hrs+${i}`]: hour }),
          { date: item.date }
        );
      }
      return item;
    });
  }

  const getSwapDetails = (empID) => {
    if (fromDate != null && toDate != null && operativeID != "") {
      const fromDateMoment = moment(fromDate);
      const toDateMoment = moment(toDate);
      const diffInDays = toDateMoment.diff(fromDateMoment, "days") + 1;
      // console.log("diffInDays", diffInDays);
      if (
        moment(fromDate).isBetween(allowedFromDate, allowedToDate, 'day', '[ ]') &&
        moment(toDate).isBetween(allowedFromDate, allowedToDate, 'day', '[ ]')
      ) {
        if (diffInDays > 10) {
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: `You can choose a period of a maximum of 10 days in a batch`,
          });
        }
        else if (moment(toDate).isSameOrAfter(fromDate)) {
          const checkedDates = Object.keys(checkedItems);
          const checked = Object.keys(checkedItems).filter((key) => {
            return checkedItems[key] === true;
          });
          const operativeInfo = operativesDetails.filter((operative) => {
            return operative?.emp_tkt_no === operativeID?.value;
          })[0];
          let fromDate_format = fromDate.format('YYYY-MM-DD');
          let toDate_format = toDate.format('YYYY-MM-DD');
          const apiFormatedData = {
            pers_no: operativeID?.value,
            co_code: operativeInfo?.co_code,
            from_date: fromDate_format,
            to_date: toDate_format,
          };
          const apiFormatedDataJson = JSON.stringify(apiFormatedData);
          // console.log("final", apiFormatedDataJson);
          const headerss = new Headers();
          headerss.append("Content-Type", "application/json");
          fetch(`${baseUrl}timeBooking/batchBookingIndividual`, {
            method: "POST",
            headers: headerss,
            body: apiFormatedDataJson,
            credentials:"include"
          })
            .then((response) => {
              dispatch(setLogin({...auth, recentStatus: response.status}))
              return response.json();
              })
            .then((responseJson) => {
              if (responseJson.totalHrs === "  -1.00") {
                showPopup({
                  type: MESSAGE_TYPE.INFORMATION,
                  contextText: MESSAGE_TYPE.INFORMATION,
                  info: `Booking for selected Dates already booked`,
                });
              } else if (responseJson.individualHrs) {
                const checkedDates = Object.keys(checkedItems);
                const checked = Object.keys(checkedItems).filter((key) => {
                  return checkedItems[key] === true;
                });
                const DateCovert = checked.map((element) =>
                  convert2(new Date(validDate(element)))
                );
                // const findMany = responseJson.individualHrs.filter(x => DateCovert.includes(x.date));
                const findMany = responseJson.individualHrs.filter(
                  (x) => x.hrs > 0
                );
                // console.log("NonZeroDates ", findMany);
                setSeletedDates(findMany);
                const h = findMany.reduce((total, item) => total + item.hrs, 0);
                // console.log("Total hrs: ", h);
                setState((prevData) => ({
                  ...prevData,
                  totalHours: h,
                  remainingHours: h,
                  bookedHours: 0,
                }));
                // const filteredDates = Object.keys(responseJson.data.bookingDateList).filter((key) => {return checkedItems['hrs'] in  ;});
                const columns = findMany.map(({ date }) =>
                  convertViewDate(date)
                );
                const columns1 = responseJson.individualHrs.map(({ date }) =>
                  convertViewDate(date)
                );
                const bookFormatDates = findMany.map(({ date }) =>
                  convertBookingDate(date)
                );
                setSelectedDates(bookFormatDates);
                const compareDates = [...columns];
                const compareDates1 = [...columns1];
                columns.splice(0, 0, "Attendance Date");
                columns1.splice(0, 0, "Attendance Date");
                setSwapDatesColumn(columns);
                setSwapDatesColumnTemp(columns1);
                const swapData = [{ date: "Day" }, { date: "Hours" }];
                const swapData1 = [{ date: "Day" }, { date: "Hours" }];
                findMany.map((data, index) => {
                  swapData[0][`day+${index}`] = datesToBook.filter((row) => {
                    return row.date === compareDates[index];
                  })[0]?.day;
                  swapData[1][`hrs+${index}`] = data.hrs;
                });
                const result = mapResponse(
                  swapData1,
                  responseJson.individualHrs
                );
                setSwapDates(swapData);
                setSwapDatesTemp(result);
                const totalHours = myState?.totalHours;
                // setState((prevData) => ({ ...prevData,remainingHours:totalHours, bookedHours:0}));
                setSessionTempData([
                  {
                    project_type: "",
                    isIndirectProject: false,
                    barrel: "",
                    project_details: "",
                    evm_activity: "",
                    module_mfl: "",
                    hrs: "",
                  },
                ]);
                setBookButtonClicked(true);
                // setState((prevData) => ({ ...prevData, totalHours: responseJson.data.tothrs}));
              } else {
                showPopup({
                  type: MESSAGE_TYPE.INFORMATION,
                  contextText: MESSAGE_TYPE.INFORMATION,
                  info: responseJson?.msg,
                });
                setBookButtonClicked(false);
                setSwapDates([]);
                setSwapDatesColumn([]);
                const totalHours = myState?.totalHours;
                setState((prevData) => ({
                  ...prevData,
                  remainingHours: totalHours,
                  bookedHours: 0,
                }));
                setSessionTempData([
                  {
                    project_type: "",
                    isIndirectProject: false,
                    barrel: "",
                    project_details: "",
                    evm_activity: "",
                    module_mfl: "",
                    hrs: "",
                  },
                ]);
              }
            })
            .catch((error) => {
              console.info(error);
            });
        } else {
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: `From date cannot be greater than to date`,
          });
        }
      } else if (toDateMoment.isAfter(moment(), 'day')) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: `Booking can only be done till current date`,
        });
      } else {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: `Please note that Time Booking for a particular month can be done as:
            (1st - 25th): Month End
            (26th - Month End): 5th day of next month.
            For Example:
            1st-25th April: 30th April
            26th-30th April: 5th May`,
        });
      }
    } else {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: `Please select all required fields`,
      });
    }
  };
  useEffect(() => {
    if (operativeID !== "") {
      indirectProjects();
      Projects();
    }
  }, [operativeID]);

  const [bookButtonClicked, setBookButtonClicked] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleOpen = () => setIsPopupOpen(true);
  const [datesData, setDates] = useState({
    endDate: "",
    startDate: "",
  });
  const [isPopupOpenFormModal, setPopupOpenFormModal] = useState(false);
  const handleOpenFormModal = () => {
    setPopupOpenFormModal(true);
  };
  const handleCloseFormModal = () => setPopupOpenFormModal(false);
  const [reseVC, setReseVC] = useState(false);
  const handleOpenVCResetModal = () => {
    setReseVC(true);
  };
  const handleCloseVCResetModal = () => setReseVC(false);
  const handleClose = () => setIsPopupOpen(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const handleOpen1 = (selected) => {
    setIsPopupOpen1(true);
    setSelectedRow(selected);
  };
  const [isPopupOpen1, setIsPopupOpen1] = useState(false);
  const handleClose1 = () => setIsPopupOpen1(false);
  const tableColumnData = [
    { minBookableHrs: 2, maxBookableHrs: 8, bookedHrs: 5, otHrs: 1 },
    { minBookableHrs: 3, maxBookableHrs: 6, bookedHrs: 4, otHrs: 0 },
    // Additional rows...
  ];
  const goNext1 = () => {
    // actionBaseVC();
  };

  const goNext = () => {
    // uploadFileData();
  };

  const ROW_HEIGHT = 38;
  const redirectToApplicationLandingPage = () => {
    history.push("/home");
  };

  const setCount = (count) => {
    setAsnCount(count);
  };

  useEffect(() => {
    // getData();
    // getdate();
  }, []);

  const showTable = () => {
    // getTableData("Yes");
    show(true);
  };

  const handleSelect = (selectedOption, name) => {
    if (name == "baseVC") {
      show(false);

      setBC(selectedOption);
      // getPlantData(selectedOption)
    } else {
      setPlant(selectedOption);
    }
  };

  const goNextForm = () => {
    var url;
    var urlMethod;

    if (userRole.includes("GDC")) {
      url = "ColourVcMISProgress";
      urlMethod = "POST";
    } else if (
      userRole.includes("Purchase") ||
      userRole.includes("Purchase-CV")
    ) {
      url = "ColourVcMISProgress";
      urlMethod = "PUT";
    } else {
      url = "ColourVcMISProgress";
      urlMethod = "POST";
    }
    const apiFormatedData = {
      VC: Bc.value,
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}${url}/`, {
      method: urlMethod,
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: "Data is Succesfully Saved",
          reloads: true, // Set reload to true or false based on your condition
        });
        history.push("/");
      })
      .catch((error) => { });
  };
  const resetVCCall = () => {
    const apiFormatedData = {
      VC: Bc.value,
    };
  };

  const exportExcel = async (excelData) => {
    var fileTypel =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    var fileExt = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { booktype: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileTypel });
    FileSaver.saveAs(data, `ColorVCDataCV${fileExt}`);
  };
  const filterExcel = async (excelData) => {
    var fileTypel =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    var fileExt = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { booktype: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileTypel });
    FileSaver.saveAs(data, `FilteredColorVCDataCV${fileExt}`);
  };

  const redirectToCreateProjectPage = () => history.push("/");
  const redirectToProjectEditPage = (id) => history.push(`/`);
  const redirectToProjectDetailsPage = (id) => history.push(`/`);
  const [deletedData, setDeletedData] = useState([]);
  const [existingDataLength, setExistingDataLength] = useState("");
  const [tableData, setTableData] = useState([]);
  const [modifiedData, setModifiedData] = useState(existingData);
  const [rowSelected, setRowSelected] = useState(null);

  const handleModifyClick = (index) => {
    setSelectedRow((prevSelectedRow) => {
      if (prevSelectedRow === index) {
        // If the same row is already selected, deselect it
        return null;
      } else {
        // Otherwise, select the new row
        return index;
      }
    });
  };

  const handleHrsChange = (event, key) => {
    const { value } = event.target;
    const newData = [...modifiedData];

    // Create the object if it doesn't exist
    if (!newData[selectedRow]) {
      newData[selectedRow] = {};
    }

    // Update the modified Hrs value
    newData[selectedRow][key] = value;
    setModifiedData((prevData) => {
      const updatedData = [...prevData];
      updatedData[selectedRow] = {
        ...existingData[selectedRow],
        [key]: value,
      };
      return updatedData;
    });
  };

  const [extractedData, setExtractedData] = useState([]);
  const [addButtonClicked, setAddButtonClicked] = useState(false);
  const [sessionTempDataLen, setSessionTempDatalen] = useState(0);
  const [processDetails, setProcessDetails] = useState(false);

  const addRow = (i) => {
    if (validateData() === true) {
      const index = selectionOptions.length;
      let items = [...selectionOptions];
      let Projectdropdown = [];
      let item = { ...items[i], projectOption: projectOption };
      const dropDown = [];
      // if (seletedDates.length > 1 && i > 0) {
      //   dropDown.push(sessionTempData[0].project_type);
      //   if (sessionTempData[0].project_type) {
      //     item = { ...items[i], projectOption: dropDown };
      //     Projectdropdown = dropDown;
      //   } else {
      //     item = { ...items[i], projectOption: "" };
      //     Projectdropdown = projectOption;
      //   }
      //   items[i] = item;
      //   setSelectionOptions(items);
      // } else if (seletedDates.length > 1 && i === 0 && items.length > 1) {
      //   let updatedOptions = [];
      //   dropDown.push(sessionTempData[0].project_type);
      //   if (items.length === 0) {
      //     updatedOptions.push(projectOption);
      //   } else {
      //     items.map((option, optionIndex) => {
      //       if (optionIndex === 0 || i === 0) {
      //         updatedOptions.push(projectOption);
      //       } else {
      //         updatedOptions.push(dropDown);
      //       }
      //     });
      //   }
      //   setSelectionOptions(updatedOptions);
      // } else {
      //   items[i] = item;
      //   setSelectionOptions(items);
      // }
      items[i] = item;
      setSelectionOptions(items);
      setChangeIndex(i);
      const newRow = {
        project_type: (
          <Select
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '35px',
              height: '100%',
             
              '&:hover': {
                borderColor: '#E9DEAE'
              },
            }),
            menuList: provided => ({
              ...provided,
              fontSize:isMobileDevice ? "10px" : "14px",
              '&::-webkit-scrollbar': {
                width: '4px !important',
                height: '6px',
                display: 'block !important',
                background: 'none',
              },
              '&::-webkit-scrollbar-track': {
                background: 'none',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#f17c7c',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#da6363',
              },
            }),
    
            multiValue: provided => ({
              ...provided,
              backgroundColor: '#C9AF28',
              maxWidth: '140px'
            }),
            singleValue: provided => ({
              ...provided,
              color: 'black',
              fontWeight:"400"
            }),
            multiValueLabel: provided => ({
              ...provided,
              color: '#fff'
            }),
            multiValueRemove: provided => ({
              ...provided,
              color: '#fff'
            }),
            valueContainer: provided => ({
              ...provided,
              cursor: 'text'
            }),
            menu: styles => ({ ...styles,                 
              width: isMobileDevice ? "100px" : "450px",
                    })  
                  }}
            // className={clsx(styles.select, styles.sel2)}
            value={sessionTempData[i] ? sessionTempData[i].project_type : ""}
            options={i === 0 ? projectOption : Projectdropdown}
            onChange={(selectedOption) =>
              checkDuplicates(
                selectedOption,
                "project_type",
                i,
                selectionOptions,
                sessionTempData,
                indirectProjects
              )
            }
            name="projectOption"
          />
        ),
        barrel: (
          <Select
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '35px',
              height: '100%',
             
              '&:hover': {
                borderColor: '#E9DEAE'
              },
            }),
            menuList: provided => ({
              ...provided,
              fontSize:isMobileDevice ? "10px" : "14px",
              '&::-webkit-scrollbar': {
                width: '4px !important',
                height: '6px',
                display: 'block !important',
                background: 'none',
              },
              '&::-webkit-scrollbar-track': {
                background: 'none',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#f17c7c',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#da6363',
              },
            }),
    
            multiValue: provided => ({
              ...provided,
              backgroundColor: '#C9AF28',
              maxWidth: '140px'
            }),
            singleValue: provided => ({
              ...provided,
              color: 'black',
              fontWeight:"400"
            }),
            multiValueLabel: provided => ({
              ...provided,
              color: '#fff'
            }),
            multiValueRemove: provided => ({
              ...provided,
              color: '#fff'
            }),
            valueContainer: provided => ({
              ...provided,
              cursor: 'text'
            }),
            menu: styles => ({ ...styles,                 
              width: isMobileDevice ? "100px" : "450px",
             })  
          }}
            // className={clsx(styles.select, styles.sel2)}
            isDisabled={
              sessionTempData[i]
                ? sessionTempData[i]["isIndirectProject"]
                : false
            }
            value={sessionTempData[i] ? sessionTempData[i]["barrel"] : ""}
            options={
              sessionTempData[i]?.project_type?.value === "Projects"
                ? projectsDropdown?.BarrelInfoList
                : ""
            }
            onChange={(selectedOption) =>
              checkDuplicates(
                selectedOption,
                "barrel",
                i,
                selectionOptions,
                sessionTempData
              )
            }
            name="barrel"
          />
        ),
        project_details: (
          <Select
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '35px',
              height: '100%',
             
              '&:hover': {
                borderColor: '#E9DEAE'
              },
            }),
            menuList: provided => ({
              ...provided,
              fontSize:isMobileDevice ? "10px" : "14px",
              '&::-webkit-scrollbar': {
                width: '4px !important',
                height: '6px',
                display: 'block !important',
                background: 'none',
              },
              '&::-webkit-scrollbar-track': {
                background: 'none',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#f17c7c',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#da6363',
              },
            }),
    
            multiValue: provided => ({
              ...provided,
              backgroundColor: '#C9AF28',
              maxWidth: '140px'
            }),
            singleValue: provided => ({
              ...provided,
              color: 'black',
              fontWeight:"400"
            }),
            multiValueLabel: provided => ({
              ...provided,
              color: '#fff'
            }),
            multiValueRemove: provided => ({
              ...provided,
              color: '#fff'
            }),
            valueContainer: provided => ({
              ...provided,
              cursor: 'text'
            }),
            menu: styles => ({ ...styles,                 
              width: isMobileDevice ? "100px" : "450px",
             })  
          }}
            // className={clsx(styles.select, styles.sel2)}
            value={
              sessionTempData[i] ? sessionTempData[i]["project_details"] : ""
            }
            options={
              sessionTempData[i]?.project_type?.value === "Projects"
                ? selectionOptions[i]?.project_details
                : sessionTempData[i]?.project_type?.value ===
                  "Indirect Projects"
                  ? indirectProjectsList
                  : ""
            }
            onChange={(selectedOption) =>
              checkDuplicates(
                selectedOption,
                "project_details",
                i,
                selectionOptions,
                sessionTempData,
                indirectProjectsList
              )
            }
            name="projectDetails"
          />
        ),
        evm_activity: (
          <Select
            isDisabled={
              sessionTempData[i]
                ? sessionTempData[i]["isIndirectProject"]
                : false
            }
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "14px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "450px",
               })  
            }}
            // className={clsx(styles.select, styles.sel2)}
            value={sessionTempData[i] ? sessionTempData[i]["evm_activity"] : ""}
            options={
              sessionTempData[i]?.project_type?.value === "Projects"
                ? selectionOptions[i]?.GateList
                : ""
            }
            onChange={(selectedOption) =>
              checkDuplicates(
                selectedOption,
                "evm_activity",
                i,
                selectionOptions,
                sessionTempData
              )
            }
            name="evmActivity"
          />
        ),
        module_mfl: (
          <Select
            isDisabled={
              sessionTempData[i]
                ? sessionTempData[i]["isIndirectProject"]
                : false
            }
            styles={{
              control: (provided, state) => ({
                ...provided,
                minHeight: '35px',
                height: '100%',
               
                '&:hover': {
                  borderColor: '#E9DEAE'
                },
              }),
              menuList: provided => ({
                ...provided,
                fontSize:isMobileDevice ? "10px" : "14px",
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
      
              multiValue: provided => ({
                ...provided,
                backgroundColor: '#C9AF28',
                maxWidth: '140px'
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                fontWeight:"400"
              }),
              multiValueLabel: provided => ({
                ...provided,
                color: '#fff'
              }),
              multiValueRemove: provided => ({
                ...provided,
                color: '#fff'
              }),
              valueContainer: provided => ({
                ...provided,
                cursor: 'text'
              }),
              menu: styles => ({ ...styles,                 
                width: isMobileDevice ? "100px" : "250px",
               })  
            }}
            // className={clsx(styles.select, styles.sel2)}
            value={sessionTempData[i] ? sessionTempData[i]["module_mfl"] : ""}
            options={
              sessionTempData[i]?.project_type?.value === "Projects"
                ? projectsDropdown?.mflList
                : ""
            }
            onChange={(selectedOption) =>
              checkDuplicates(
                selectedOption,
                "module_mfl",
                i,
                selectionOptions,
                sessionTempData
              )
            }
            name="module"
          />
        ),
        hrs: (
          <ValidatingTextField
            variant="outlined"
            size="small"
            value={sessionTempData[i] ? sessionTempData[i]["hrs"] : ""}
            onChange={(e) =>
              handleCustomSelectChange(
                e,
                "hrs",
                i,
                selectionOptions,
                sessionTempData
              )
            }
            name="hour"
            onBlur={() => { handleHrsMouseLeave(i) }}
            inputProps={{
              "data-testid": "remark-input",
            }}
            style={{ width: "100%" }}
          />
        ),
      };
      setExistingData([...existingData, newRow]);
      const newEmptyRow = {
        project_type: "",
        isIndirectProject: false,
        barrel: "",
        project_details: "",
        evm_activity: "",
        module_mfl: "",
        hrs: "",
      };
      setSessionTempData([...sessionTempData, newEmptyRow]);
    }
  };

  const doneAdding = () => {
    const newRow = {};
    Object.keys(data[0]).forEach((key) => {
      newRow[key] = data[0][key];
    });
    setSessionData([...sessionData, newRow]);
  };

  const extractProjectDetailsAndHrs = async (data, setResult) => {
    const result = [];
    for (let i = 0; i < data.length; i += 1) {
      const item = data[i];

      // Check if the item is an object
      if (typeof item === "object" && item !== null) {
        const projectDetails = item.project_details ?? "";
        const hrs = item.hrs ?? "";

        if (projectDetails && hrs) {
          result.push({ projectDetails, hrs });
        }
      }
    }
    // console.log("Result Data -> ", typeof result, result);

    setResult(result);
  };

  const [checkedItems, setCheckedItems] = useState({});
  // console.log("checkedItems", checkedItems);
  const handleCheckboxChange = (event, index) => {
    // console.log("date", index);
    const date = moment(index).format("DD-MM-YYYY");
    const { checked } = event.target;
    setCheckedItems((prevState) => ({
      ...prevState,
      [index]: checked,
    }));
  };

  useEffect(() => {
    const extractedData = Object.entries(checkedItems)
      .filter(([_, checked]) => checked)
      .map(([index, _]) => parseInt(index))
      .filter((index) => index < existingData.length)
      .map((index) => existingData[index].project_details);

    setDeletedData(extractedData);
  }, [checkedItems]);

  

  const renderHTML = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                // onError={dateValidation}
                autoOk
                clearable
                inputVariant="outlined"
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                onChange={(date) => setToDate(date)}
                value={toDate}
                emptyLabel="dd/mm/yyyy"
                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                // minDate={moment(startDate, "YYYY-MM-DD").add(1, 'days')}
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              //  maxDate={moment().toDate()}
              />
            </div>
          </div>
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                // onError={dateValidation}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                autoOk
                clearable
                inputVariant="outlined"
                onChange={(date) => setFromDate(date)}
                value={fromDate}
                emptyLabel="dd/mm/yyyy"
                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                // minDate={moment(startDate, "YYYY-MM-DD").add(1, 'days')}
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              //  maxDate={moment().toDate()}
              />
            </div>
          </div>
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={clsx(styles.rowDiv)}>
            <div className={clsx(styles.formDiv)}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                style={{ marginLeft: "10px" }}
                variant="primary"
                onClick={() => setSubmitClicked(true)}
              // data-testid="save-confirm"
              >
                SUBMIT
              </Button>

              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                style={{ marginLeft: "10px" }}
                variant="primary"
                onClick={() => setViewDatesToBook(true)}
              // data-testid="save-confirm"
              >
                Dates To Book
              </Button>
              {viewDatesToBook && (
                <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton
                  )}
                  style={{ marginLeft: "10px" }}
                  variant="primary"
                  onClick={() => setViewDatesToBook(false)}
                // data-testid="save-confirm"
                >
                  Close
                </Button>
              )}
            </div>
          </div>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        {viewDatesToBook && (
          <Grid item md={12} lg={12} xs={12}>
            <div className={clsx(styles.lableDiv)}>
              <label>Bookable Dates</label>
            </div>
            <TableSimple
              tableColumnData={[
                {
                  action: "Link",
                  date: "10-05-2023",
                  bookedHrs: "WED",
                },
                {
                  action: "Link",
                  date: "10-05-2023",
                  bookedHrs: "WED",
                },
                {
                  action: "Link",
                  date: "10-05-2023",
                  bookedHrs: "WED",
                },
              ]}
              tableHeaderLabel={["Action", "Date", "Day"]}
              TableRowHederAling="start"
              size="small"
              headerColor="#2C73D2"
              className="custom-table"
            />
          </Grid>
        )}
      </Grid>
    </div>
  );

  const renderData = () => (
    <>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={12} lg={12} xs={12}>
          <TableSimple
            tableColumnData={[
              {
                projectCode: "W.22.EV.711",
                projectDescription: "Test Project - Time Booking",
                gate: "FSR-Final Status Report",
                aggregate: "Vehicle",
                activity: "Advance Engg",
                hour: 4,
                delete: (
                  <div>
                    <IconButton color="primary" className={styles.deleteIcon}>
                      <EditIcon />
                    </IconButton>

                    <IconButton color="primary" className={styles.deleteIcon}>
                      <DeleteIcon />
                    </IconButton>
                  </div>
                ),
              },
              {
                projectCode: "W.22.EV.711",
                projectDescription: "Test Project - Time Booking",
                gate: "FSR-Final Status Report",
                aggregate: "Vehicle",
                activity: "Advance Engg",
                hour: 4,
                delete: (
                  <div>
                    <IconButton color="primary" className={styles.deleteIcon}>
                      <EditIcon />
                    </IconButton>

                    <IconButton color="primary" className={styles.deleteIcon}>
                      <DeleteIcon />
                    </IconButton>
                  </div>
                ),
              },
            ]}
            tableHeaderLabel={[
              "Project/Indirect Code",
              "Project/Indirect Description ",
              "Gate",
              "Aggregate",
              "Activity",
              "Hour",
              "Action",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#2C73D2"
            className="custom-table"
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
          marginBottom: "10px",
          justifyContent: "center",
        }}
        columns={12}
      >
        <Grid item md={1} lg={1} xs={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button className={clsx(styles.actionButton)} variant="primary">
                Save
              </Button>

              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="primary"
                style={{ marginLeft: "10px" }}
              >
                CANCEL
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );

  useEffect(() => {
    setBookButtonClicked(false)
  }, [fromDate, toDate])

  const handleOnclickDate = (date) => {
    const dateVal = date;
      setFromDate(dateVal);
      setToDate(dateVal);
  }

  const renderDatesToBook = () => (
    <div className={styles.formGroup} style={{ marginTop: "10px" }}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={5} lg={5} xs={12} sm={12}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Operative Details</label>
            </div>
            <div className={styles.formDiv}>
              <Select
                className={clsx(styles.select, styles.sel2)}
                // isMulti
                value={operativeID !== "" ? operativeID : ""}
                options={operativeList}
                // onChange={(selectedOption) => {
                //   setProDefDetails(selectedOption);
                // }}
                onChange={handleOperativeIDChange}
                name="OperativeDetails"
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
        <Grid item md={3} lg={3} xs={1} sm={1}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                style={{ color: "white", backgroundColor: "#488f71", padding: "17px 10px" }}
                onClick={() => {
                  setIsPopupOpen(true)
                }}
                disabled={datesToBook.length === 0}
                data-testid="confirm-action"
              >
                Dates to Book
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        {/* <Grid item md={12} lg={12} xs={12} sm={12}>
          {datesToBook.length > 0 && (
            <TableSimple
              tableColumnData={datesToBook}
              tableHeaderLabel={["Select_10", "Date_50", "Day_40"]}
              TableRowHederAling="start"
              size="small"
              headerColor="#E6F2FF"
              className="custom-table"
            />
          )}
        </Grid> */}
        <Grid item md={4} lg={4} sm={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                // onError={dateValidation}
                autoOk
                clearable
                inputVariant="outlined"
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                // onChange={(date) => setFromDate(date)}
                onChange={(e) => handleOnclickDate(e)}
                value={fromDate}
                emptyLabel="dd/mm/yyyy"
                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                // minDate={moment(startDate, "YYYY-MM-DD").add(1, 'days')}
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              //  maxDate={moment().toDate()}
              />
            </div>
          </div>
        </Grid>
        <Grid item md={4} lg={4} sm={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                // onError={dateValidation}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                autoOk
                clearable
                inputVariant="outlined"
                onChange={(date) => setToDate(date)}
                value={toDate}
                emptyLabel="dd/mm/yyyy"
                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                // minDate={moment(startDate, "YYYY-MM-DD").add(1, 'days')}
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              //  maxDate={moment().toDate()}
              />
            </div>
          </div>
        </Grid>
        <Grid item md={4} lg={4} xs={4} sm={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                style={{ color: "white", backgroundColor: "#488f71" }}
                onClick={() => {
                  getSwapDetails();
                }}
                data-testid="confirm-action"
              >
                Book
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
      {/* <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{
          marginTop: "10px",
        }}
        columns={12}
      >
        <Grid item md={5} lg={5} />
        <Grid item md={4} lg={4} xs={4} sm={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              {datesToBook.length > 0 && (
                <Button
                  style={{ color: "black", backgroundColor: "#E6F2FF" }}
                  onClick={() => {
                    getSwapDetails();
                  }}
                  data-testid="confirm-action"
                >
                  Book
                </Button>
              )}
            </div>
          </div>
        </Grid>
      </Grid> */}
    </div>
  );

  const renderBookedDetails = () => (
    <div className={styles.formGroup} style={{ marginTop: "10px" }}>
      <Grid item md={12} lg={12} xs={12}>
        <div
          style={{ maxHeight: "400px", overflow: "auto", marginTop: "10px" }}
        >
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    backgroundColor: "#E6F2FF",
                  }}
                >
                  Select
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    backgroundColor: "#E6F2FF",
                  }}
                >
                  Project / Indirect Project
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    backgroundColor: "#E6F2FF",
                  }}
                >
                  Barrel
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    backgroundColor: "#E6F2FF",
                  }}
                >
                  Project Details
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    backgroundColor: "#E6F2FF",
                  }}
                >
                  EVM Activity
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    backgroundColor: "#E6F2FF",
                  }}
                >
                  Module (MFL)
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    backgroundColor: "#E6F2FF",
                  }}
                >
                  Hrs
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    backgroundColor: "#E6F2FF",
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {sessionData.map((item, index) => (
                <tr key={index}>
                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                    <input
                      type="checkbox"
                      checked={checkedItems[index] || false}
                      onChange={(event) => handleCheckboxChange(event, index)}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                    }}
                  >
                    {item.project_type}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                    }}
                  >
                    {item.barrel}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                    }}
                  >
                    {item.project_details}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                    }}
                  >
                    {item.evm_activity}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                    }}
                  >
                    {item.module_mfl}
                  </td>
                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                    {selectedRow === index ? (
                      <ValidatingTextField
                        variant="outlined"
                        size="small"
                        value={modifiedData[index]?.hrs || ""}
                        onChange={(e) => handleHrsChange(e, "hrs")}
                        name="hour"
                        inputProps={{
                          "data-testid": "remark-input",
                        }}
                        style={{ width: "100%" }}
                      />
                    ) : (
                      item.hrs
                    )}
                  </td>
                  <td style={{ border: "1px solid #000", padding: "5px" }}>
                    <IconButton
                      color="primary"
                      className={styles.deleteIcon}
                      onClick={() => {
                        handleModifyClick(index);
                      }}
                    >
                      <EditIcon />
                    </IconButton>

                    <IconButton style={{ color: "#f17c7c" }}>
                      <DeleteIcon />
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <label
          style={{ color: "#f17c7c", fontWeight: "bold", marginTop: "10px" }}
        >
          Total: 16.5 Balance: 0
        </label>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px", justifyContent: "center" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
                onClick={() => {
                  setProcessDetails(true);
                }}
              >
                Save
              </Button>

              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                onClick={() => {
                  extractProjectDetailsAndHrs(modifiedData, setExtractedData);
                }}
                style={{ marginRight: "5px" }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const isScrollBar = isMobileDevice ?  styles.scrollBar : "";

  const renderAttendanceDetails = () => (
    <div className={styles.formGroup} style={{ marginTop: "10px" }}>
      <label style={{ color: "#f17c7c", fontWeight: "bold" }}>
        Total Bookable Hrs : {myState.totalHours || ""}
      </label>
      {swapDates.length > 0 && (
        <div 
        className={clsx(
          styles.myGrid,
          isScrollBar
        )}>
        <TableSimple
          tableColumnData={swapDatesTemp}
          tableHeaderLabel={swapDatesColumnTemp}
          TableRowHederAling="start"
          size="small"
          headerColor="#E6F2FF"
          className="custom-table"
        />
        </div>
      )}
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={clsx(
          styles.myGrid,
          isScrollBar
        )}
        columns={12}
      >
        <Grid item md={12} lg={12} xs={12}>
          <TableSimple
            tableColumnData={existingData.map((info, index) => ({
              projectType: info.project_type,
              barrel: info.barrel,
              projectDetails: info.project_details,
              evmActivity: info.evm_activity,
              module: info.module_mfl,
              hrs: info.hrs,
              action: (
                <>
                  <IconButton
                    style={{ color: "#f17c7c" }}
                    className={styles.deleteIcon}
                    onClick={() => {
                      handleDelete(index);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </>
              ),
            }))}
            tableHeaderLabel={[
              "Project / Indirect Project_80",
              "Barrel_110",
              "Project/Indirect Details_120",
              "Gate (EVM Activity)_120",
              "Module (MFL)_80",
              "Hrs_40",
              "Action_30",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={clsx(
          styles.myGrid,
          isScrollBar
        )}
        columns={12}
      >
        <Grid item md={1} lg={1}>
          <Button
            style={{ color: "black", backgroundColor: "#E6F2FF" }}
            disabled={myState.remainingHours === 0}
            onClick={() => {
              addRow(existingData.length);
            }}
            data-testid="confirm-action"
          >
            +
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px", justifyContent: "flex-end" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={3} lg={3}>
          <TableSimple
            tableColumnData={[
              {
                label: "Total Hrs Booked",
                value: myState?.bookedHours ? myState?.bookedHours : 0,
              },
              {
                label: "Hrs Remaining",
                value: myState?.remainingHours ? myState?.remainingHours : 0,
              },
            ]}
            tableHeaderLabel={["", ""]}
            TableRowHederAling="left"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px", justifyContent: "center" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                disabled={
                  myState?.bookedHours === "" || myState?.bookedHours === 0 ||
                  (myState?.bookedHours !== myState?.totalHours &&
                    myState.remainingHours > 0)
                }
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
                onClick={() => {
                  saveTimeBooking();
                }}
              >
                Save
              </Button>

              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="tertiary"
                onClick={resetState}
                style={{ marginRight: "5px" }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
        <div
          className={styles.backButtonLastRefreshedDateWrapper}
          style={{ display: "none" }}
        >
          <BackButton
            action="Back"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Time Booking" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel
              userInfo={[
                {
                  Name: "Aditya Mathur",
                  "SAP ID": 122355,
                  "BC No": "122355",
                  LOC: "Engineering and Research Center",
                },
              ]}
            />
          </div>
        </div>

        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >
          <CustomFormGroup header="Register Time Operative" body={renderDatesToBook()} />
          {bookButtonClicked && <>{renderAttendanceDetails()}</>}
          {addButtonClicked && <>{renderBookedDetails()}</>}
          {/* {processDetails && <>{renderProcessedDetails()}</>} */}
        </div>

        {flag && (
          <div
            className={styles.tableView}
            style={{ height: "86%", padding: "0 2em" }}
          ></div>
        )}
      </div>
      <ResetModalVC
        isPopupOpen={reseVC}
        handleCloseVCModal={handleCloseVCResetModal}
        resetVCCall={resetVCCall}
      />

      <ResetModalF
        isPopupOpen={isPopupOpenFormModal}
        handleCloseFormModal={handleCloseFormModal}
        goNextForm={goNextForm}
      />
      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        goNext={goNext}
      />

      <ResetModal2
        isPopupOpen1={isPopupOpen1}
        handleClose1={handleClose1}
        goNext1={goNext1}
      />
    </>
  );
};
function ResetModalVC({ isPopupOpen, handleCloseVCModal, resetVCCall }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm Reset
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            {/* <p> On confirmation, All existing data will be overwritten by the uploaded data.</p> */}
            <p>
              On confirmation, Selected VC BoM will get reset and all changes
              made will be lost
            </p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCloseVCModal}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleCloseVCModal();
              resetVCCall();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModalF({ isPopupOpen, handleCloseFormModal, goNextForm }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm Submit
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            {/* <p> On confirmation, All existing data will be overwritten by the uploaded data.</p> */}
            <p>On confirmation ,VC BoM data will submit</p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCloseFormModal}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleCloseFormModal();
              goNextForm();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal({ isPopupOpen, handleClose, goNext }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm file Upload
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            {/* <p> On confirmation, All existing data will be overwritten by the uploaded data.</p> */}
            <p>On confirmation ,Records will be appended.</p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              goNext();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal2({ isPopupOpen1, handleClose1, goNext1 }) {
  return (
    <Dialog
      open={isPopupOpen1}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Selected data will be deleted
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            <p> On confirmation, Selected data will be deleted.</p>
            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose1}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              goNext1();
              handleClose1();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  goNext: PropTypes.func.isRequired,
};
ResetModalF.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleCloseFormModal: PropTypes.func.isRequired,
  goNextForm: PropTypes.func.isRequired,
};
ResetModalVC.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleCloseVCModal: PropTypes.func.isRequired,
  resetVCCall: PropTypes.func.isRequired,
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  goNext: PropTypes.func.isRequired,
};
ResetModal2.propTypes = {
  isPopupOpen1: PropTypes.bool.isRequired,
  handleClose1: PropTypes.func.isRequired,
  goNext1: PropTypes.func.isRequired,
};

export default withAllowedOperationsProvider(
  BatchTimeBooking,
  RESOURCE_TYPE.PROJECT
);